import React from 'react';

import { RolesContext } from './roles-context';

import { useTypedSelector } from 'state';

export function RolesContextProvider({ children }) {
  const { spots } = useTypedSelector(state => state.spotSelector);
  const { spotId: superAdminSpotId } = useTypedSelector(state => state.auth.superAdmin);
  const isSuperAdmin = useTypedSelector(state => state.currentUser.isSuperAdmin);

  const spotId = useTypedSelector(state => state.application.spotId);

  const isAdmin = spots.findIndex(spot => spot.id === spotId && spot.type === 'admin') !== -1;
  const isModerationViewer =
    spots.findIndex(spot => spot.id === spotId && spot.type === 'moderationViewer') !== -1;
  const finalIsSuperAdmin = isSuperAdmin || superAdminSpotId === spotId;

  return (
    <RolesContext.Provider value={{ isAdmin, isModerationViewer, isSuperAdmin: finalIsSuperAdmin }}>
      {children}
    </RolesContext.Provider>
  );
}
